exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".video{height:100%;width:100%;-o-object-fit:fill;object-fit:fill}", "", {"version":3,"sources":["/home/philipeatela/videopeel-plugin/src/components/Video/style.css"],"names":[],"mappings":"AAAA,OACE,YAAa,AACb,WAAY,AACZ,mBAAoB,AACjB,eAAiB,CACrB","file":"style.css","sourcesContent":[".video {\n  height: 100%;\n  width: 100%;\n  -o-object-fit: fill;\n     object-fit: fill;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Video/style.css
// module id = 852
// module chunks = 0 1